<template>
  <div class="target-bars">
    <TargetBars
      :height="250"
      :targetsData="targetsData"
      :currentData="realizedData"
      :labels="labels"
      :title="title"
    />
  </div>
</template>

<script>
import TargetBars from "./Charts/TargetBars";
export default {
  props: ["targetHistories", "targetType"],
  components: { TargetBars },
  computed: {
    activeTargetHistories() {
      return this.targetHistories.filter(th => !!th.target);
    },
    labels() {
      // NOTE: This assumes that the target histories are arranged in ascending date order.
      const arr = this.activeTargetHistories.map(th => this.getLabel(th.date));
      return this.getLast(arr, 30);
    },
    targetsData() {
      switch (this.targetType) {
        case "recordings":
          return this.activeTargetHistories.map(
            th => th.target.targetDailyRecordings
          );
        case "seconds":
          return this.activeTargetHistories.map(
            th => th.target.targetDailySeconds
          );
        case "spellings":
          return this.activeTargetHistories.map(
            th => th.target.targetDailySpellings
          );
        default:
          return [];
      }
    },
    realizedData() {
      switch (this.targetType) {
        case "recordings":
          return this.activeTargetHistories.map(
            th => th.target.currentDailyRecordings
          );
        case "seconds":
          return this.activeTargetHistories.map(
            th => th.target.currentDailySeconds
          );
        case "spellings":
          return this.activeTargetHistories.map(
            th => th.target.currentDailySpellings
          );
        default:
          return [];
      }
    },
    title() {
      switch (this.targetType) {
        case "recordings":
          return "Recordings";
        case "seconds":
          return "Seconds";
        case "spellings":
          return "Words";
        default:
          return "";
      }
    }
  },
  methods: {
    getLabel(dateString) {
      let d = new Date(dateString);
      const month = d.getMonth() + 1;
      const day = d.getDate();
      return `${day}/${month}`;
    },
    getLast(arr, count) {
      return arr.slice(Math.max(arr.length - count, 0));
    }
  }
};
</script>

<style lang="scss" scoped></style>
